export default {
  EXITING: 'history::exiting',
};



// WEBPACK FOOTER //
// ./src/constants/history-event-types.js